/** Comp types recorded when force-closing an order as "free". */
export const COMP_TYPES = [
    'staff_meal',
    'owner',
    'guest',
    'training',
    'marketing',
    'waste',
    'other',
];
/** Human-readable labels (English) — dashboards/POS can i18n on top of the key. */
export const COMP_TYPE_LABELS = {
    staff_meal: 'Staff meal',
    owner: 'Owner',
    guest: 'Guest',
    training: 'Training',
    marketing: 'Marketing',
    waste: 'Waste',
    other: 'Other',
};
//# sourceMappingURL=comp.js.map